<template>
  <stepper-layout
    :stepTitle="'Move-In Instructions'"
    :stepIcon="'follow_the_signs'"
  >
    <v-card class="pa-4" v-if="moveInInstructions">
      <span data-testid="move-in-instructions" v-html="moveInInstructions.instructions" />
    </v-card>
    <div
      v-if="moveInInstructions && moveInInstructions.id"
      class="text-body-2 mt-3 pb-4"
      data-testid="updated-at"
    >
      This facility's move-in instructions last updated {{ timestamp(moveInInstructions.updated_at) }}
    </div>
  </stepper-layout>
</template>

<script>
import StepperLayout from "@/layouts/StepperLayout";
import moment from "moment";
export default {
  name: "MoveInInstructions",
  components: { StepperLayout },
  methods: {
    timestamp(date) {
      return moment.utc(date).local().fromNow();
    }
  },
  computed: {
    moveInInstructions() {
      return this.$store.state.facilities.moveInInstructions;
    }
  }
};
</script>
